import PortalIdParser from 'PortalIdParser';
import { Link } from 'foundations-components/transitional/components/Link';
// @ts-expect-error untyped file
import { getMessageId } from 'conversations-message-history/message-history/operators/getMessageId';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getFullUrl } from 'hubspot-url-utils';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageClippedLink = message => {
  const messageId = getMessageId(message);
  const baseUrl = getFullUrl('api').replace('https://', '');
  const href = `//${baseUrl}/conversations-email/v1/app-messages/${messageId}/static-redirect?portalId=${PortalIdParser.get()}`;
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "100",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "conversations-inbox-message-history.common-message.clippedMessageLink_jsx",
      options: {
        href
      },
      elements: {
        Link
      }
    })
  });
};
MessageClippedLink.displayName = 'MessageClippedLink';
export default MessageClippedLink;